import withContainer from 'components/Container/withContainer';
import { BigHeadline, CenterContainer, TextLNormal } from 'ui/Styled/Styled';

const AccessDeniedPageContent = () => {
    return (
        <CenterContainer>
            <BigHeadline>Доступ запрещен</BigHeadline>
            <TextLNormal>У вас нет доступа к этой странице.</TextLNormal>
        </CenterContainer>
    );
};

export default withContainer(AccessDeniedPageContent);
